import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { coverImageUrl } from '../../../utility/coachCertification'

import classes from './CertificationHero.module.scss'

const CertificationHero = ({ certification }) => {
  const { t } = useTranslation()

  return (
    <section className={classes.hero}>
      <img src={coverImageUrl(certification)} alt='' className={classes.photo} />
      <div className={classes.scrim} />
      <div className={classNames('position-relative', classes.inner)}>
        <span className={classes.eyebrow}>{t('portal.certification.details.eyebrow', { level: certification.level })}</span>
        <h1 className={classes.title}>{certification.name}</h1>
        {certification.description && <p className={classes.description}>{certification.description}</p>}
      </div>
    </section>
  )
}

CertificationHero.propTypes = {
  certification: PropTypes.shape({
    level: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    coverImage: PropTypes.shape({ largeFileUrl: PropTypes.string }),
  }).isRequired,
}

export default CertificationHero
